import { Info } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function ContextPanel(): JSX.Element {
  return (
    <aside className="hidden lg:flex lg:flex-col border-l bg-background min-h-0 p-4 gap-4">
      <h2 className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
        Ngữ cảnh
      </h2>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm flex items-center gap-1.5">
            <Info className="size-3.5" />
            Chưa có ngữ cảnh
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-xs text-muted-foreground leading-relaxed">
            Khi anh nói chuyện với em về một phiếu hoặc đối tác cụ thể, em sẽ ghim
            thông tin liên quan ở đây để tham chiếu nhanh.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm">Trạng thái hệ thống</CardTitle>
        </CardHeader>
        <CardContent className="text-xs space-y-1.5">
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Auth Service</span>
            <span className="size-2 rounded-full bg-success" aria-label="online" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Chat Gateway</span>
            <span className="size-2 rounded-full bg-success" aria-label="online" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Odoo</span>
            <span className="size-2 rounded-full bg-muted-foreground" aria-label="unknown" />
          </div>
        </CardContent>
      </Card>
    </aside>
  );
}
